module.exports = __webpack_public_path__ + "assets/btn_google_signin_dark_normal_web.png?696c081ae56a5d4674d5da24e7810ab7";